import axios from '@/shared/axios';
import { BaseResponse } from '@/types/web.interface';

import type { UserInfo } from '@/types/home';

export async function editEmail(locale: string, params?: any) {
  const res = await axios.get<BaseResponse<any>>('/edit/email', {
    params,
    headers: {
      'Current-Language': locale,
    },
  });
  return res.data;
}

export async function editPassword(locale: string, params?: any) {
  const res = await axios.get<BaseResponse<any>>('/edit/password', {
    params,
    headers: {
      'Current-Language': locale,
    },
  });
  return res.data;
}

// 营销邮件通知开关
export async function marketEmailNotify(open: boolean) {
  const operate = open ? 'open' : 'close';
  const res = await axios.post<BaseResponse<any>>(`/ins/monitor/email/market/notify/${operate}`);
  return res.data;
}

// 获取用户信息
export async function getUserInfo() {
  const res = await axios.get<BaseResponse<UserInfo>>('/user/info');
  return res.data;
}

// 发送邮箱验证码
export async function sendEmailVerificationCode(email: string, type: 'register' | 'login') {
  // 模拟接口：2 秒后返回
  // return new Promise((resolve) => {
  //   setTimeout(() => {
  //     resolve({ code: 0, message: 'success' } as BaseResponse<any>);
  //   }, 2000);
  // });
  const res = await axios.post<BaseResponse<any>>(`/user/send_verification_code`, { email, type });
  return res.data;
}

// 邮箱验证码注册
export async function emailVerificationRegister(
  email: string,
  verification_code: string,
  password: string,
  source_domain?: string,
) {
  // 模拟成功接口
  // return new Promise((resolve) => {
  //   setTimeout(() => {
  //     resolve({ code: 0, message: 'success' } as BaseResponse<any>);
  //   }, 2000);
  // });
  const res = await axios.post<BaseResponse<any>>(`/user/email_reg`, {
    email,
    verification_code,
    password,
    source_domain,
  });
  return res.data;
}
